import React from "react";
import { LoadingDialog } from "../../../_metronic/_partials/controls";

export function LoadingDialogCustom({isLoading, text}) {
  return <LoadingDialog isLoading={isLoading} text={text || `Loading ...`}/>;
}
